import { render, staticRenderFns } from "./base_pan1.vue?vue&type=template&id=7d1befea&scoped=true"
import script from "./base_pan1.vue?vue&type=script&lang=js"
export * from "./base_pan1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1befea",
  null
  
)

export default component.exports